var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGif = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 15.375a1.125 1.125 0 0 1-1.125-1.125v-9c0-.621.504-1.125 1.125-1.125h13.5c.621 0 1.125.504 1.125 1.125v9c0 .621-.504 1.125-1.125 1.125H3.25ZM1 14.25a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 19 14.25v-9A2.25 2.25 0 0 0 16.75 3H3.25A2.25 2.25 0 0 0 1 5.25v9Zm7.958-2.558c-.204.244-.492.434-.865.57-.373.133-.786.2-1.239.2-.476 0-.894-.103-1.254-.31a2.105 2.105 0 0 1-.83-.906c-.194-.395-.294-.86-.299-1.393v-.374c0-.55.092-1.024.276-1.424.186-.403.453-.71.8-.922.35-.214.76-.32 1.228-.32.652 0 1.162.156 1.53.468.367.31.585.761.653 1.356H7.855c-.05-.315-.162-.546-.336-.692-.171-.146-.408-.219-.71-.219-.385 0-.679.145-.88.435-.201.29-.303.72-.306 1.291v.352c0 .576.11 1.012.329 1.306.219.295.54.442.963.442.425 0 .729-.09.91-.272v-.948H6.794v-.834h2.164v2.194Zm2.126.695H9.951V6.888h1.133v5.499Zm2.187-2.247h2.175v-.914H13.27v-1.42h2.447v-.918h-3.58v5.499h1.133V10.14Z",
    fill: "currentColor"
  })));
};
export { SvgGif as ReactComponent };